import React from 'react'
import { ButtonIconSeeker, AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { copyToClipboard } from '@ui-seeker/utils'
import { useTheme, Box, Typography } from '@mui/material'

import { useToast } from '@hooks'
import { BI_ROUTES, BACKEND_APIS } from '@constants'
import { BIFormData, BIOpenUrlModal, BIUrlId } from 'Pages/BusinessLogistics/BI/Page/@signals'
import useDeleteUrl from 'Pages/BusinessLogistics/BI/Page/@hooks/useDeleteUrl'


export default function BIPageWrapperActions() {
	const { showToast } = useToast()
	const { palette } = useTheme()
	const { handleDeleteUrl } = useDeleteUrl()


	const onAjaxCommon = options => options.map(option => ({
		label: `${option.label}`,
		path: option.path,
		value: `${option.value}`,
	}))

	const encodeToBase64 = (obj) => {
		const jsonString = JSON.stringify(obj)
		const bytes = new TextEncoder().encode(jsonString)
		return btoa(String.fromCharCode(...bytes))
	}


	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '20%' }}>
		<ButtonIconSeeker
			icon="link"
			iconWeight="duotone"
			tooltip="Copy filters link to clipboard"
			iconProps={{
				style: {
					'--fa-primary-color': palette.primary.main,
					'--fa-secondary-color': palette.primary.light,
					'--fa-secondary-opacity': 1,
				},
			}}
			onClick={() => {
				try {
					copyToClipboard(`rentacar.dataseekers.com${BI_ROUTES.PATH}?sp=${encodeToBase64(BIFormData.value)}`)
					showToast.success('Url copied to clipboard')
				} catch {
					showToast.error('Could not copy to clipboard')
				}
			}}
		/>

		<ButtonIconSeeker
			icon="floppy-disk"
			iconWeight="duotone"
			tooltip="Save filters link"
			iconProps={{
				style: {
					'--fa-primary-color': palette.primary.main,
					'--fa-secondary-color': palette.primary.light,
					'--fa-secondary-opacity': 1,
				},
			}}
			onClick={() => BIOpenUrlModal.value = `${BI_ROUTES.PATH}?sp=${encodeToBase64(BIFormData.value)}`}/>
		<AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
			sx={{ p: 1 }}
			value={BIUrlId.value}
			urlAjax={`${BACKEND_APIS.DASHBOARD}/get-filters`}
			onAjax={onAjaxCommon}
			getOptionLabel={({ label }) => label || ''}
			formatOptionLabel={option => <LabelComponent {...option} handleDelete={handleDeleteUrl} />}
			onChange={(e) => {
				BIUrlId.value = e.target.value
			}}
			filters={{
				urlId: BIUrlId.value,
			}}
		/>
	</Box>
}


function LabelComponent({label , value, path, handleDelete}) {

	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
			<Typography
				sx={{ width: '100%' }}
				onClick={() => {
					BIUrlId.value = value
					window.open(path, '_blank')
				}}
			>{label}
			</Typography>
			<ButtonIconSeeker
				icon='xmark'
				iconProps={{ sx: { color: 'white', backgroundColor: 'colors.red', width: '20px', height: '20px', borderRadius: '3px' }}}
				tooltip='Delete this saved filter'
				onClick={() => {
					handleDelete(value, label)
				}}
			/>
	</Box>
}